/* unplugin-vue-components disabled */import { render } from "./CollectUserLocation.vue?vue&type=template&id=b1a2051a&scoped=true"
import script from "./CollectUserLocation.vue?vue&type=script&lang=js"
export * from "./CollectUserLocation.vue?vue&type=script&lang=js"

import "./CollectUserLocation.vue?vue&type=style&index=0&id=b1a2051a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1a2051a"]])

export default __exports__